import React, {Component} from 'react';
import * as messageConstants from '../../../shared/messages';

class SloParameterItem extends Component {

  render() {
    return (
        <div>
          <li>{this.props.location}</li>
          {this.props.binding ? (
                  <li className="pl-33">{messageConstants.SLO_BINDING}{this.props.binding}</li>)
              : null}
          {this.props.responseLocation ? (
                  <li className="pl-33">{messageConstants.SLO_RESPONSE}{this.props.responseLocation}</li>)
              : null}
        </div>
    );
  }
}

export default SloParameterItem;